/**
 * Shared style constants for ProductCard components
 */

/** Container classes shared between ProductCard and ProductCardSkeleton */
export const CARD_CONTAINER_CLASSES =
  'group relative flex flex-col items-center bg-white rounded border border-border-color px-3 py-3 xl:px-5 xl:py-4 w-full min-w-[280px] max-w-[420px] h-auto xl:h-[520px] hover:shadow-box-shadow justify-between gap-3'
